module.exports = __webpack_public_path__ + "img/avatar.2d9f55d7.jpg";